var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartWrapper"},[_c('div',{attrs:{"id":"chartdiv"}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('Specific')))]),_c('span',{staticClass:"text right"},[_vm._v(_vm._s(_vm.$t('Broad')))])])}
var staticRenderFns = []

export { render, staticRenderFns }